<script>
  export let data = '';
  export let viewBox = '0 0 24 24';
  
  export let cssClass= null;
  export let size = '24px';
  export let width = size;
  export let height = size;

  export let color = 'currentColor';
  export let stroke = color;
  export let fill = color;

  $: elements = data
    .replace(/<svg ([^>]*)>/, '')
    .replace('</svg>', '')
</script>

<svg class={cssClass}
xmlns="http://www.w3.org/2000/svg"
  {width}
  {height}
  {viewBox}
  {stroke}
  {fill}
>
  {@html elements}
</svg>

<style>
  svg {
    pointer-events: none;
  }
</style>
